angular.module('website').controller('website.newWaiverCtrl', ["$scope", "$rootScope", "$stateParams", "$location", "$http", "$document", "$q", "$filter", "$timeout", "WaiverValidationService", "CreditCardValidationService", "WaiverService", "waiverPath", "DataService", "loadingAnimation", "flash", "waiver", function($scope, $rootScope, $stateParams, $location, $http, $document, $q, $filter, $timeout, WaiverValidationService, CreditCardValidationService, WaiverService, waiverPath, DataService, loadingAnimation, flash, waiver) {
  var checkBypassFamilySelection, checkForMissingDetails, createGDPRData, getDefaultAttending, getPreselectedMembership, initContacts, isCardholderNameProvided, isCreditCard, isPaymentDetailsPresent, isPaymentFormActive, isPaymentFormValid, isPaymentProviderAgreementAccepted, isSignatureReady, isStripeFormActive, isWitnessSignatureReady, mergeContactsDetails, onPaymentDetailsSubmitReady, onWaiverComplete, preselectMembershipPlan, recalculateContactsPosition, removeBlankContacts, safeApply, save, setLinksTarget, shouldVerifyEzidebit, submitPaymentDetails, updateMergeTags, validate, validateRequest, verifyEzidebit;
  $scope.pageParams = {};
  $scope.signature = {};
  $scope.witnessSignature = {};
  $scope.walletDetails = {};
  $scope.waiver = waiver.plain ? waiver.plain() : waiver;
  $scope.waiver.rootObjectName = 'signed_waiver';
  $scope.waiver.withoutNamespace = true;
  $scope.currency = DataService.currency;
  $scope.country = DataService.gym_country;
  $scope.waiver.signed_as = '';
  $scope.gymDomain = DataService.domain;
  $scope.gymTz = DataService.gym_tz;
  $scope.gymName = DataService.gym_name;
  $scope.gymConfig = DataService.gym_config;
  $scope.isClickAndPay = !!$stateParams.click_and_pay_plan;
  $scope.pixelId = DataService.gym_config.facebook_pixel_id_for_signed_waiver_page;
  $scope.pixelEvent = DataService.gym_config.facebook_pixel_event_for_signed_waiver_page;
  $scope.gtmId = DataService.gym_config.gtm_code_for_signed_waiver_page;
  $scope.submitRecaptchaToken = null;
  $scope.dobMinDate = new Date(1900, 0, 1);
  $scope.dobMaxDate = moment.tz($scope.gymTz).endOf('day').toDate();
  $scope.paymentDetailsDirty = false;
  $scope._initialPaymentMethod = null;
  $scope.generateRecaptchaToken = function() {
    return $rootScope.$emit('recaptcha:execute');
  };
  shouldVerifyEzidebit = function() {
    var ref, ref1, ref2;
    return ((ref = $scope.waiver) != null ? (ref1 = ref.signed_waiver_form_attributes) != null ? ref1.payment_authority_active : void 0 : void 0) && $scope.waiver.gym_payment_provider === 'ezidebit' && !!((ref2 = $scope.walletDetails) != null ? ref2.editable : void 0) && !!$scope.paymentDetailsDirty;
  };
  $scope.onRecaptchaSubmitted = function(token) {
    $scope.submitRecaptchaToken = token;
    $rootScope.$emit('recaptcha:completed', token);
    if (shouldVerifyEzidebit()) {
      return verifyEzidebit();
    }
  };
  $scope.isBankAccountProviderAvailable = WaiverService.isBankAccountProviderAvailable;
  $scope.isCreditCardProviderAvailable = WaiverService.isCreditCardProviderAvailable;
  WaiverService.getEzidebitFees($scope.waiver, DataService.gym_id).then(function(fees) {
    return $scope.ezidebitFees = fees;
  });
  $scope.$watch('waiver.signed_waiver_contacts_attributes[0]', WaiverService.syncContactFields($scope.waiver), true);
  checkBypassFamilySelection = function() {
    switch (false) {
      case $scope.waiver.allow_signing_by !== 'adult':
        return $scope.signAs('signed_as_adult');
      case !$scope.isPrefilledNac():
        return $scope.signAs('signed_as_adult_with_family');
      case !$scope.gymConfig.bypass_family_waiver_selection:
        return $scope.signAs('signed_as_adult');
      case $scope.waiver.allow_signing_by !== 'adult_with_family':
        return $scope.signAs('signed_as_adult_with_family');
    }
  };
  getPreselectedMembership = function() {
    var clickAndPayId;
    if ($scope.isClickAndPay) {
      clickAndPayId = parseInt($stateParams.click_and_pay_plan, 10);
    }
    return WaiverService.getPreselectedMembership($scope.waiver, {
      clickAndPayId: clickAndPayId
    });
  };
  preselectMembershipPlan = function() {
    var plans, preselectedMembership, waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    plans = waiverForm.membership_plan_options;
    if (!(waiverForm.membership_options_active && plans.length)) {
      return;
    }
    preselectedMembership = getPreselectedMembership();
    return $scope.waiver.signed_waiver_contacts_attributes.forEach(function(c) {
      return c.membership_plan_id = preselectedMembership != null ? preselectedMembership.id : void 0;
    });
  };
  setLinksTarget = function() {
    return $timeout(function() {
      return angular.element('.panel-body a').each(function(i, element) {
        return element.target = '_blank';
      });
    });
  };
  createGDPRData = function() {
    var createPolicyResponse, paymentPrivacyPolicies, privacyPolicies;
    createPolicyResponse = function(policy) {
      return angular.extend({}, policy, {
        id: void 0,
        privacy_policy_id: policy.id,
        accepted: false,
        policy_heading: policy.derived_heading,
        policy_content: policy.derived_content
      });
    };
    privacyPolicies = $scope.waiver.privacy_policies.filter(function(policy) {
      return policy.context !== 'waiver_payment_authority';
    });
    paymentPrivacyPolicies = $scope.waiver.privacy_policies.filter(function(policy) {
      return policy.context === 'waiver_payment_authority';
    });
    if (privacyPolicies.length) {
      $scope.waiver.privacy_policy_responses_attributes = privacyPolicies.map(createPolicyResponse);
    }
    if (paymentPrivacyPolicies.length) {
      return $scope.waiver.signed_waiver_wallet_detail_attributes.privacy_policy_responses_attributes = paymentPrivacyPolicies.map(createPolicyResponse);
    }
  };
  $scope.signAs = function(value) {
    var ref;
    $scope.waiver.signed_as = value;
    initContacts();
    updateMergeTags();
    $scope.walletDetails = WaiverService.initPaymentDetails($scope.waiver);
    $scope.paymentDetailsDirty = false;
    $scope._initialPaymentMethod = (ref = $scope.walletDetails) != null ? ref.payment_method : void 0;
    WaiverService.prepopulateChildDetails($scope.waiver);
    setLinksTarget();
    createGDPRData();
    return preselectMembershipPlan();
  };
  $scope.selectAttendingDisabled = function(contact) {
    return contact.contact_id && contact.contact_type.toLowerCase() !== 'prospect';
  };
  $scope.displayPaymentDetails = function(provider) {
    switch ($scope.walletDetails.payment_method) {
      case 'credit_card':
        return $scope.waiver.credit_card_provider === provider;
      case 'bank_account':
        return $scope.waiver.bank_account_provider === provider;
    }
  };
  $scope.isPrefilledNac = function() {
    var contact;
    contact = $scope.waiver.signed_waiver_contacts_attributes[0];
    return contact && contact.id && !contact.attending;
  };
  initContacts = function() {
    var contacts;
    contacts = $scope.waiver.signed_waiver_contacts_attributes;
    contacts.forEach(function(contact, index) {
      if ($scope.isSignedAsAdult() && index > 0) {
        return contact._destroy = 1;
      } else {
        return contact.member_number_read_only = !!contact.member_number;
      }
    });
    if (!contacts.length) {
      $scope.addContact();
    }
    if ($scope.isSignedAsAdult()) {
      return $scope.waiver.signed_waiver_contacts_attributes = contacts;
    } else {
      if (contacts.length === 1) {
        return $scope.addContact();
      }
    }
  };
  $scope.isFieldRequired = function(field, first) {
    return WaiverService.isFieldRequired($scope.waiver, field, first);
  };
  $scope.isFieldAvailable = function(field) {
    return WaiverService.isFieldAvailable($scope.waiver, field);
  };
  $scope.isPaymentMethodPresent = function() {
    var walletDetails;
    walletDetails = $scope.waiver.signed_waiver_wallet_detail_attributes;
    return walletDetails.customer_ref && !!walletDetails.last4;
  };
  getDefaultAttending = function(isPrimary) {
    if (isPrimary && !$scope.isSignedAsAdult() && !$scope.isNonAttending()) {
      return void 0;
    } else {
      return !$scope.isNonAttending();
    }
  };
  $scope.addContact = function() {
    var contact, contacts, isPrimary, preselectedMembership;
    contacts = $scope.waiver.signed_waiver_contacts_attributes;
    isPrimary = contacts.length === 0;
    preselectedMembership = getPreselectedMembership();
    contact = {
      primary: isPrimary,
      attending: getDefaultAttending(isPrimary),
      membership_plan_id: preselectedMembership != null ? preselectedMembership.id : void 0
    };
    if (!isPrimary) {
      angular.extend(contact, WaiverService.getParentDetails($scope.waiver));
    }
    $scope.waiver.signed_waiver_contacts_attributes.push(contact);
    return recalculateContactsPosition();
  };
  $scope.removeContact = function(contact) {
    var index;
    if (contact.contact_id) {
      contact._destroy = 1;
    } else {
      index = $scope.waiver.signed_waiver_contacts_attributes.indexOf(contact);
      $scope.waiver.signed_waiver_contacts_attributes.splice(index, 1);
    }
    recalculateContactsPosition();
    if ($scope.activeContacts().length === 1) {
      return $scope.addContact();
    }
  };
  mergeContactsDetails = function(contacts) {
    var originalContacts;
    originalContacts = $scope.waiver.signed_waiver_contacts_attributes;
    return $scope.waiver.signed_waiver_contacts_attributes = originalContacts.map(function(contact, index) {
      var updatedContact;
      updatedContact = contacts.find(function(c) {
        return contact.position === c.position;
      }) || {};
      return angular.extend(contact, updatedContact);
    });
  };
  recalculateContactsPosition = function() {
    return $scope.waiver.signed_waiver_contacts_attributes.forEach(function(contact, index) {
      return contact.position = index + 1;
    });
  };
  removeBlankContacts = function() {
    $scope.waiver.signed_waiver_contacts_attributes.forEach(function(contact, index) {
      if (!(contact.email || contact.first_name || contact.last_name || index === 0)) {
        if (contact.id) {
          return contact._destroy = 1;
        } else {
          return $scope.waiver.signed_waiver_contacts_attributes.splice(index, 1);
        }
      }
    });
    return recalculateContactsPosition();
  };
  $scope.activeContacts = function() {
    return _.filter($scope.waiver.signed_waiver_contacts_attributes, function(contact) {
      return !contact._destroy;
    });
  };
  $scope.isContactPresent = function(item) {
    return !item._destroy;
  };
  $scope.isSignedAsAdult = function() {
    return $scope.waiver.signed_as === 'signed_as_adult';
  };
  $scope.isMember = function() {
    return $scope.waiver.waiver_type === 'member';
  };
  $scope.isNonAttending = function() {
    return $scope.waiver.waiver_type === 'non_attending_contact';
  };
  $scope.onAttendingToggle = function(contact) {
    var ref, ref1;
    if (!contact.attending) {
      contact.member_number = void 0;
    }
    if ((ref = $scope.waiver.signed_waiver_form_attributes.family_membership_strategy) === 'every_attendee_pays_membership' || ref === 'each_signee_chooses_own_membership') {
      return contact.membership_plan_id = contact.attending ? (ref1 = getPreselectedMembership()) != null ? ref1.id : void 0 : null;
    }
  };
  $scope.onContactDetailsChanged = function(contactIndex) {
    if (contactIndex !== 0) {
      return;
    }
    return updateMergeTags();
  };
  $scope.emergencyContactDetailRequiredPlaceholder = function() {
    if ($scope.waiver.signed_waiver_form_attributes.emergency_contact_details_required) {
      return ' (required)';
    } else {
      return '';
    }
  };
  updateMergeTags = function() {
    var contact, country, waiverDateValue, waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    contact = $scope.waiver.signed_waiver_contacts_attributes[0];
    country = $scope.waiver.waiver_header_address_country;
    waiverDateValue = moment().tz($scope.gymTz).format('MMMM Do YYYY');
    return $scope.waiver.mergedContent = {
      electronic_consent_content: $filter('replaceWaiverMergeTags')(waiverForm.electronic_consent_content, contact, country, waiverDateValue),
      gym_tacs_content: $filter('replaceWaiverMergeTags')(waiverForm.gym_tacs_content, contact, country),
      waiver_release_content: $filter('replaceWaiverMergeTags')(waiverForm.waiver_release_content, contact, country)
    };
  };
  $scope.hasPayment = function() {
    return WaiverService.hasPayment($scope.waiver);
  };
  $scope.isFormReady = function() {
    var waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    return !$scope.pageParams.isLoading && waiverForm.electronic_consent_acceptance && isPaymentFormValid() && isSignatureReady() && isWitnessSignatureReady();
  };
  isSignatureReady = function() {
    var waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    if (waiverForm.signature_active) {
      return $scope.signature.signatureDataUrl;
    } else {
      return true;
    }
  };
  isWitnessSignatureReady = function() {
    var waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    if (waiverForm.witness_signature_active) {
      return $scope.witnessSignature.signatureDataUrl && waiverForm.witness_name;
    } else {
      return true;
    }
  };
  isPaymentFormActive = function() {
    var waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    return waiverForm.payment_authority_active && $scope.walletDetails.editable;
  };
  isCreditCard = function() {
    return $scope.walletDetails.payment_method === 'credit_card';
  };
  isPaymentFormValid = function() {
    if (!isPaymentFormActive()) {
      return true;
    }
    if (!isPaymentProviderAgreementAccepted()) {
      return false;
    }
    if (!isPaymentDetailsPresent()) {
      return false;
    }
    if (!isCreditCard()) {
      return true;
    }
    return (!isStripeFormActive() || $scope.walletDetails.complete) && isCardholderNameProvided();
  };
  isCardholderNameProvided = function() {
    var ref, ref1, ref2;
    if ((ref = $scope.walletDetails) != null ? ref.nameOnCard : void 0) {
      return CreditCardValidationService.nameValid((ref1 = $scope.walletDetails) != null ? ref1.nameOnCard : void 0);
    } else {
      return !isStripeFormActive() || CreditCardValidationService.nameValid((ref2 = $scope.walletDetails) != null ? ref2.nameOnCard : void 0);
    }
  };
  isStripeFormActive = function() {
    return $scope.waiver.credit_card_provider === 'stripe' && $scope.walletDetails.payment_method === 'credit_card';
  };
  isPaymentDetailsPresent = function() {
    return WaiverValidationService.isPaymentDetailsPresent($scope.walletDetails);
  };
  isPaymentProviderAgreementAccepted = function() {
    return $scope.pageParams.paymentProviderServiceAgreement;
  };
  $scope.isPaymentDetailsInvalid = function() {
    return WaiverValidationService.isPaymentDetailsInvalid($scope.waiver, $scope.walletDetails);
  };
  $scope.togglePaymentDetails = function() {
    var ref, ref1;
    if ($scope.walletDetails.editable) {
      $scope.walletDetails = WaiverService.initPaymentDetails($scope.waiver);
      $scope.paymentDetailsDirty = false;
      return $scope._initialPaymentMethod = (ref = $scope.walletDetails) != null ? ref.payment_method : void 0;
    } else {
      $scope.walletDetails = WaiverService.getNewPaymentDetails($scope.waiver);
      $scope.paymentDetailsDirty = false;
      return $scope._initialPaymentMethod = ((ref1 = $scope.waiver.signed_waiver_wallet_detail_attributes) != null ? ref1.payment_method : void 0) || $scope._initialPaymentMethod;
    }
  };
  $scope.$watch('walletDetails', function(val) {
    var bankDirty, ccDirty, methodChanged, ref;
    if (!((ref = $scope.walletDetails) != null ? ref.editable : void 0)) {
      return;
    }
    methodChanged = !!$scope._initialPaymentMethod && ((val != null ? val.payment_method : void 0) != null) && val.payment_method !== $scope._initialPaymentMethod;
    ccDirty = !!((val != null ? val.nameOnCard : void 0) || (val != null ? val.cardNumber : void 0) || (val != null ? val.expiryMonth : void 0) || (val != null ? val.expiryYear : void 0) || (val != null ? val.cvc : void 0));
    bankDirty = !!((val != null ? val.account_name : void 0) || (val != null ? val.account_number : void 0) || (val != null ? val.bsb : void 0));
    return $scope.paymentDetailsDirty = !!(methodChanged || ccDirty || bankDirty);
  }, true);
  submitPaymentDetails = function() {
    if ($scope.displayPaymentDetails('ezidebit')) {

    } else {
      return onPaymentDetailsSubmitReady();
    }
  };
  verifyEzidebit = function() {
    var url;
    url = `/websites/${$scope.gymDomain}/waivers/${$scope.waiver.waiver_code}/signed_waivers/verify_ezidebit`;
    return $http.post(url).then(function(response) {
      $scope.publicKey = response.data.public_key;
      return $timeout(function() {
        return onPaymentDetailsSubmitReady();
      }, 100);
    }, function(response) {
      flash.error = "Request could not be completed. Please try again";
      loadingAnimation.hide();
      return $scope.pageParams.isLoading = false;
    });
  };
  $scope.onRecaptchaError = function() {
    flash.error = "Unable to perform CAPTCHA check. If enabled, consider disabling VPN / IP tracking software and try again.";
    loadingAnimation.hide();
    return $scope.pageParams.isLoading = false;
  };
  onPaymentDetailsSubmitReady = function() {
    var ref;
    if (!(((ref = $scope.walletDetails) != null ? ref.editable : void 0) && $scope.paymentDetailsDirty)) {
      return;
    }
    return WaiverService.setEzidebitCustomerContactDetails($scope.waiver, $scope.country).then(function() {
      return $timeout(function() {
        var signedWaiverWalletDetail;
        signedWaiverWalletDetail = $scope.waiver.signed_waiver_wallet_detail_attributes;
        if (signedWaiverWalletDetail.customer_ref && signedWaiverWalletDetail.active_on_ezidebit) {
          if ($scope.walletDetails.payment_method === 'credit_card') {
            return angular.element('#updateCreditCard').click();
          } else {
            return angular.element('#updateBankAccount').click();
          }
        } else {
          if ($scope.walletDetails.payment_method === 'credit_card') {
            return angular.element('#submitCreditCard').click();
          } else {
            return angular.element('#submitBankAccount').click();
          }
        }
      });
    });
  };
  checkForMissingDetails = function() {
    var invalidForm;
    invalidForm = WaiverValidationService.getInvalidFormName($scope.waiver, $scope.walletDetails);
    if (invalidForm) {
      $document.scrollToElementAnimated(angular.element(invalidForm));
      return $scope.pageParams.isLoading = false;
    } else {
      return submitPaymentDetails();
    }
  };
  save = function() {
    var method, params, ref, url, waiverCode;
    waiverCode = (ref = $scope.waiver.waiver_code) != null ? ref.toLowerCase() : void 0;
    params = {
      recaptcha_token: $scope.submitRecaptchaToken,
      signed_waiver: $scope.waiver
    };
    url = $scope.waiver.id ? `/websites/${$scope.gymDomain}/waivers/${waiverCode}/signed_waivers/${$scope.waiver.prefill_code}` : `/websites/${$scope.gymDomain}/waivers/${waiverCode}/signed_waivers`;
    method = $scope.waiver.id ? "PUT" : "POST";
    return $http({
      method: method,
      url: url,
      data: params
    }).then(function(response) {
      return response.data;
    }).catch(function(error) {
      var ref1;
      return flash.error = ((ref1 = error.data) != null ? ref1.message : void 0) || "Request could not be completed. Please try again.";
    });
  };
  validateRequest = function() {
    if ($scope.waiver.id) {
      return waiverPath.one('signed_waivers', $scope.waiver.prefill_code).one('validate').doPUT($scope.waiver);
    } else {
      return waiverPath.all('signed_waivers').doPOST($scope.waiver, 'validate');
    }
  };
  validate = function() {
    var deferred, primaryContact;
    deferred = $q.defer();
    primaryContact = $scope.waiver.signed_waiver_contacts_attributes[0];
    if (primaryContact.attending === void 0) {
      primaryContact.errors = {
        attending: ['This field is required.']
      };
      deferred.reject({
        data: $scope.waiver
      });
      return deferred.promise;
    }
    validateRequest().then(function() {
      return WaiverValidationService.validateWaiver($scope.waiver).then(function() {
        return deferred.resolve();
      }, function(response) {
        loadingAnimation.hide();
        $scope.waiver.errors = response.data.errors;
        return checkForMissingDetails();
      });
    }, function(response) {
      return deferred.reject(response);
    });
    return deferred.promise;
  };
  $scope.saveWaiver = function() {
    return save().then(function(data) {
      if (!data) {
        return;
      }
      $scope.signedWaiver = data;
      loadingAnimation.hide();
      return onWaiverComplete();
    }).catch(function(error) {
      var errors, ref, ref1, ref2;
      loadingAnimation.hide();
      $scope.pageParams.isLoading = false;
      if (error != null ? (ref = error.data) != null ? ref.errors : void 0 : void 0) {
        $scope.waiver.errors = error.data.errors;
        errors = $scope.waiver.errors;
        if (((ref1 = errors.payment_provider_error) != null ? ref1[0] : void 0) || ((ref2 = errors['signed_waiver_wallet_detail.privacy_policy_responses.accepted']) != null ? ref2[0] : void 0)) {
          return $document.scrollToElementAnimated(angular.element('#walletDetails'));
        }
      }
    });
  };
  onWaiverComplete = function() {
    return $timeout(function() {
      if (window.dataLayer && $scope.signedWaiver.http_referer_source) {
        return window.dataLayer.push({
          source: $scope.signedWaiver.http_referer_source
        });
      }
    }, 500);
  };
  $scope.questionnaireValidationWrapper = null;
  $scope.hasQuestionnaireErrors = false;
  safeApply = function(fn) {
    if (!$scope.$$phase && !$scope.$root.$$phase) {
      return $scope.$apply(fn);
    } else {
      return fn();
    }
  };
  $scope.responseCollectorsByPosition = {};
  $scope.registerQuestionnaireResponseCollector = function(position, fn) {
    return $scope.responseCollectorsByPosition[position] = fn;
  };
  $scope.questionnaireValidators = [];
  $scope.registerQuestionnaireValidator = function(validatorFn) {
    return $scope.questionnaireValidators.push(validatorFn);
  };
  $scope.unRegisterQuestionnaireValidator = function(validatorFn) {
    var idx;
    idx = $scope.questionnaireValidators.indexOf(validatorFn);
    if (idx >= 0) {
      return $scope.questionnaireValidators.splice(idx, 1);
    }
  };
  $scope.validateQuestionnaires = function(callback) {
    var completed, results;
    results = [];
    completed = 0;
    if ($scope.questionnaireValidators.length === 0) {
      callback(true);
      return;
    }
    return $scope.questionnaireValidators.forEach(function(validatorFn) {
      return validatorFn(function(isValid) {
        results.push(isValid);
        completed += 1;
        if (completed === $scope.questionnaireValidators.length) {
          return callback(results.every(Boolean));
        }
      });
    });
  };
  $scope.submit = function() {
    var signature, waiverForm, witnessSignature;
    $scope.noConnection = false;
    loadingAnimation.show();
    $scope.pageParams.isLoading = true;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    $scope.waiver.signed_waiver_contact_questionnaires_attributes = [];
    angular.forEach($scope.responseCollectorsByPosition, function(collectorFn, pos) {
      var responses;
      if (typeof collectorFn === 'function') {
        responses = collectorFn();
        return Array.prototype.push.apply($scope.waiver.signed_waiver_contact_questionnaires_attributes, responses);
      }
    });
    if (waiverForm.signature_active && !$scope.signature.isEmpty) {
      signature = $scope.signature.accept();
      $scope.waiver.signed_waiver_form_attributes.signature = signature.dataUrl.replace(/^data:image\/\w*;base64,/, '');
    }
    if (waiverForm.witness_signature_active && !$scope.witnessSignature.isEmpty) {
      witnessSignature = $scope.witnessSignature.accept();
      $scope.waiver.signed_waiver_form_attributes.witness_signature = witnessSignature.dataUrl.replace(/^data:image\/\w*;base64,/, '');
    }
    if (!$scope.waiver.signed_waiver_form_attributes.payment_authority_active) {
      $scope.waiver.signed_waiver_wallet_detail_attributes = void 0;
    }
    $scope.waiver.first_membership_attributes = void 0;
    removeBlankContacts();
    return $q.all([
      (function() {
        var deferred;
        deferred = $q.defer();
        if (typeof $scope.validateQuestionnaires === 'function') {
          $scope.validateQuestionnaires(function(isValid) {
            safeApply(function() {
              return $scope.hasQuestionnaireErrors = !isValid;
            });
            return deferred.resolve(isValid);
          });
        } else {
          safeApply(function() {
            return $scope.hasQuestionnaireErrors = false;
          });
          deferred.resolve(true);
        }
        return deferred.promise;
      })(),
      validate()
    ]).then(function([questionnaireValid]) {
      var recaptchaTokenHandler;
      if (!questionnaireValid) {
        safeApply(function() {
          $scope.pageParams.isLoading = false;
          return loadingAnimation.hide();
        });
        return;
      }
      recaptchaTokenHandler = $rootScope.$on('recaptcha:completed', function(e, token) {
        recaptchaTokenHandler();
        $scope.submitRecaptchaToken = token;
        if (waiverForm.payment_authority_active && $scope.walletDetails.editable) {
          if ($scope.paymentDetailsDirty) {
            return submitPaymentDetails();
          } else {
            return $scope.saveWaiver();
          }
        } else {
          return $scope.saveWaiver();
        }
      });
      return $scope.generateRecaptchaToken();
    }, function(response) {
      return safeApply(function() {
        if (response.data) {
          $scope.waiver.errors = response.data.errors;
          mergeContactsDetails(response.data.signed_waiver_contacts_attributes);
          checkForMissingDetails();
        } else {
          $scope.noConnection = true;
          $scope.pageParams.isLoading = false;
        }
        return loadingAnimation.hide();
      });
    });
  };
  if ($scope.waiver.signed_waiver_form_attributes) {
    return checkBypassFamilySelection();
  }
}]);
